module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/base-publication-form-part/user-information-form-part/user-information-form-part.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/base-publication-form-part/user-information-form-part/user-information-form-part.component.scss
// module chunks = main